import TokensTable from './TokensTable';

export default TokensTable;